import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { trainingsApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import BtnSelect from "../../../UI/Buttons/BtnSelect";
import { FilterExtention, Filter, FilterTypesEnum, Filters, FilterItem } from "../../../UI/Filter";
import TrainingForm from "./TrainingForm";
import Trainings from "./Trainings";
import classes from "./TrainingsFilter.module.css";

const TrainingsFilter = ({ trainings, setTrainings, type, view }) => {

    const { texts } = useSelector(state => state.translate);
    const applicationId = useSelector(state => state.application.applicationId);

    const [currentTraining, setCurrentTraining] = useState();
    const componentMounted = useRef(true);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    const save = (inputs) => {
        const trainingAddInput = {
            id: inputs.id,
            name: inputs.name,
            description: inputs.description,
            url: inputs.url,
            contentData: JSON.stringify({ type: type }),
            lang: inputs.lang,
            thumbnail: inputs.fileData.file,
            applicationId: applicationId
        }

        trainingsApi[inputs.id ? "trainingsUpdatePost" : "trainingsAddPost"](trainingAddInput, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "TrainingsPage", line: 16 }))
            } else {
                if (componentMounted.current) {
                    const parse = JSON.parse(resdata.contentData ?? "{}");
                    if (inputs.id) // update
                        setTrainings(prev => {
                            const updateIndex = prev.findIndex(t => t.id === inputs.id);
                            const newState = [...prev];
                            newState[updateIndex] = { ...resdata, type: parse.type }
                            return newState;
                        })
                    else // add
                        setTrainings(prev => {
                            return [...prev, { ...resdata, type: parse.type }]
                        })
                }
            }
        })
    }

    const editTraining = (id) => {
        setCurrentTraining(trainings.find(t => t.id === id))
    }

    const deleteTraining = (id) => {
        trainingsApi.trainingsDeleteIdPost(id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "TrainingsPage", line: 67 }))
            } else {
                if (componentMounted.current) {
                    setTrainings(prev => {
                        return prev.filter(t => t.id !== id)
                    })
                }
            }
        })
    }

    return (
        <div className={classes.TrainingsFilter}>
            {!view && <BtnSelect dropClass={classes.Btn} checked onClick={() => setCurrentTraining({})}>+ {texts.uploadNewTraining}</BtnSelect>}
            {currentTraining && <TrainingForm onClose={() => setCurrentTraining(false)} onSave={save} training={currentTraining}></TrainingForm>}
            <div>
                <FilterExtention list={trainings && trainings.filter(t => t.type === type)} >
                    <Filters>
                        {/* fix that Filters cannot get null children */}
                        {(() => { 
                            const filtersArr = [<Filter key="free" name="free" text={texts.freeFilter} type={FilterTypesEnum.free}></Filter>]
                            if (!view)
                                filtersArr.push(<Filter key="lang" name="lang" text={texts.filterByLanguage} type={FilterTypesEnum.valuesList} values={{ he: texts.he, ar: texts.ar }}></Filter>)
                            return filtersArr;
                        })()}
                    </Filters>
                    <FilterItem>
                        <Trainings view={view} handleEdit={editTraining} handleDelete={deleteTraining}></Trainings>
                    </FilterItem>
                </FilterExtention>
            </div>

        </div>
    )
}

export default TrainingsFilter;